import VZFLandingpage from './VZFLandingpage'

export default VZFLandingpage
